import { c as _c } from "react/compiler-runtime";
import { Button } from "@repo/ui/components/ui/button";
import { cn } from "@repo/ui/lib/utils";
import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { Check, Clock, ExternalLink, Loader2, MapPin, RotateCcw, Trash2, User } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { AuditHistoryAccordion } from "@/lib/components/admin/AuditHistoryAccordion";
import { RejectDialog } from "@/lib/components/admin/RejectDialog";
import { FeatureCard } from "@/lib/components/FeatureCard";
import { PlaceFeatureMap } from "@/lib/components/map/PlaceFeatureMap";
import { sameCoord } from "@/lib/utils/geolocation";
import { trpc } from "@/router";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PlaceReviewPanel(t0) {
  const $ = _c(156);
  const {
    placeId,
    isApproving,
    isRejecting,
    isRepositioning,
    onApprove,
    onReject,
    onReposition,
    rejectDialogOpen,
    onOpenRejectDialog,
    onCloseRejectDialog
  } = t0;
  const [picked, setPicked] = useState(null);
  let t1;
  if ($[0] !== placeId) {
    t1 = trpc.places.byIdFull.queryOptions({
      id: placeId
    });
    $[0] = placeId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: place,
    isLoading
  } = useQuery(t1);
  let t2;
  if ($[2] !== placeId) {
    t2 = trpc.places.byId.queryOptions({
      id: placeId
    });
    $[2] = placeId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: meta
  } = useQuery(t2);
  const savedKey = meta ? `${meta.location.latitude}:${meta.location.longitude}` : "none";
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setPicked(null);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== savedKey) {
    t4 = [savedKey];
    $[5] = savedKey;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  bb0: {
    if (!place || !meta) {
      let t6;
      if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = [];
        $[7] = t6;
      } else {
        t6 = $[7];
      }
      t5 = t6;
      break bb0;
    }
    let t6;
    if ($[8] !== meta || $[9] !== picked) {
      t6 = picked ?? {
        latitude: meta.location.latitude,
        longitude: meta.location.longitude
      };
      $[8] = meta;
      $[9] = picked;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    const effective = t6;
    let list;
    if ($[11] !== effective.latitude || $[12] !== effective.longitude || $[13] !== meta || $[14] !== picked || $[15] !== place.features) {
      list = [];
      if (picked) {
        let t7;
        if ($[17] !== meta.location.latitude || $[18] !== meta.location.longitude) {
          t7 = {
            kind: "place",
            latitude: meta.location.latitude,
            longitude: meta.location.longitude,
            draggable: false,
            ghost: true
          };
          $[17] = meta.location.latitude;
          $[18] = meta.location.longitude;
          $[19] = t7;
        } else {
          t7 = $[19];
        }
        list.push(t7);
      }
      let t7;
      if ($[20] !== effective.latitude || $[21] !== effective.longitude) {
        t7 = {
          kind: "place",
          latitude: effective.latitude,
          longitude: effective.longitude,
          draggable: true
        };
        $[20] = effective.latitude;
        $[21] = effective.longitude;
        $[22] = t7;
      } else {
        t7 = $[22];
      }
      list.push(t7);
      for (const f of place.features ?? []) {
        if (!f.location) {
          continue;
        }
        list.push({
          kind: "feature",
          id: f.id,
          latitude: f.location.latitude,
          longitude: f.location.longitude,
          label: f.featureType?.name ?? "Funktion",
          status: f.status,
          draggable: false
        });
      }
      $[11] = effective.latitude;
      $[12] = effective.longitude;
      $[13] = meta;
      $[14] = picked;
      $[15] = place.features;
      $[16] = list;
    } else {
      list = $[16];
    }
    t5 = list;
  }
  const markers = t5;
  if (isLoading || !place || !meta) {
    let t6;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = /*#__PURE__*/_jsx("div", {
        className: "flex h-full items-center justify-center p-8",
        children: /*#__PURE__*/_jsx(Loader2, {
          className: "h-6 w-6 animate-spin text-gray-400"
        })
      });
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    return t6;
  }
  let isDirty;
  let t10;
  let t11;
  let t12;
  let t13;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[24] !== isApproving || $[25] !== isRejecting || $[26] !== markers || $[27] !== meta.categoryName || $[28] !== meta.createdAt || $[29] !== meta.creator?.name || $[30] !== meta.location.latitude || $[31] !== meta.location.longitude || $[32] !== onApprove || $[33] !== onOpenRejectDialog || $[34] !== picked || $[35] !== place.id || $[36] !== place.name) {
    const savedLocation = {
      latitude: meta.location.latitude,
      longitude: meta.location.longitude
    };
    isDirty = picked !== null && !sameCoord(picked, savedLocation);
    t12 = "flex h-full flex-col overflow-y-auto";
    let t14;
    if ($[46] !== place.name) {
      t14 = /*#__PURE__*/_jsx("h2", {
        className: "truncate text-lg font-bold text-gray-900",
        children: place.name
      });
      $[46] = place.name;
      $[47] = t14;
    } else {
      t14 = $[47];
    }
    let t15;
    if ($[48] !== place.id) {
      t15 = {
        plats: place.id
      };
      $[48] = place.id;
      $[49] = t15;
    } else {
      t15 = $[49];
    }
    let t16;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = /*#__PURE__*/_jsx(ExternalLink, {
        className: "h-4 w-4"
      });
      $[50] = t16;
    } else {
      t16 = $[50];
    }
    let t17;
    if ($[51] !== t15) {
      t17 = /*#__PURE__*/_jsx(Link, {
        to: "/karta",
        search: t15,
        className: "text-gray-400 hover:text-brand",
        title: "\xD6ppna p\xE5 karta",
        children: t16
      });
      $[51] = t15;
      $[52] = t17;
    } else {
      t17 = $[52];
    }
    let t18;
    if ($[53] !== t14 || $[54] !== t17) {
      t18 = /*#__PURE__*/_jsxs("div", {
        className: "flex items-center gap-2",
        children: [t14, t17]
      });
      $[53] = t14;
      $[54] = t17;
      $[55] = t18;
    } else {
      t18 = $[55];
    }
    let t19;
    if ($[56] !== meta.categoryName) {
      t19 = meta.categoryName && /*#__PURE__*/_jsx("span", {
        className: "rounded bg-gray-100 px-1.5 py-0.5 font-medium text-gray-600",
        children: meta.categoryName
      });
      $[56] = meta.categoryName;
      $[57] = t19;
    } else {
      t19 = $[57];
    }
    let t20;
    if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = /*#__PURE__*/_jsx(User, {
        className: "h-3 w-3"
      });
      $[58] = t20;
    } else {
      t20 = $[58];
    }
    const t21 = meta.creator?.name ?? "Ok\xE4nd";
    let t22;
    if ($[59] !== t21) {
      t22 = /*#__PURE__*/_jsxs("span", {
        className: "flex items-center gap-1",
        children: [t20, t21]
      });
      $[59] = t21;
      $[60] = t22;
    } else {
      t22 = $[60];
    }
    let t23;
    if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
      t23 = /*#__PURE__*/_jsx(Clock, {
        className: "h-3 w-3"
      });
      $[61] = t23;
    } else {
      t23 = $[61];
    }
    let t24;
    if ($[62] !== meta.createdAt) {
      t24 = new Date(meta.createdAt).toLocaleDateString("sv-SE");
      $[62] = meta.createdAt;
      $[63] = t24;
    } else {
      t24 = $[63];
    }
    let t25;
    if ($[64] !== t24) {
      t25 = /*#__PURE__*/_jsxs("span", {
        className: "flex items-center gap-1",
        children: [t23, t24]
      });
      $[64] = t24;
      $[65] = t25;
    } else {
      t25 = $[65];
    }
    let t26;
    if ($[66] !== t19 || $[67] !== t22 || $[68] !== t25) {
      t26 = /*#__PURE__*/_jsxs("div", {
        className: "mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-gray-500",
        children: [t19, t22, t25]
      });
      $[66] = t19;
      $[67] = t22;
      $[68] = t25;
      $[69] = t26;
    } else {
      t26 = $[69];
    }
    let t27;
    if ($[70] !== t18 || $[71] !== t26) {
      t27 = /*#__PURE__*/_jsxs("div", {
        className: "min-w-0",
        children: [t18, t26]
      });
      $[70] = t18;
      $[71] = t26;
      $[72] = t27;
    } else {
      t27 = $[72];
    }
    let t28;
    if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
      t28 = /*#__PURE__*/_jsx("div", {
        className: "shrink-0",
        children: /*#__PURE__*/_jsx("span", {
          className: "rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-700",
          children: "V\xE4ntar"
        })
      });
      $[73] = t28;
    } else {
      t28 = $[73];
    }
    let t29;
    if ($[74] !== t27) {
      t29 = /*#__PURE__*/_jsxs("div", {
        className: "flex items-start justify-between gap-3",
        children: [t27, t28]
      });
      $[74] = t27;
      $[75] = t29;
    } else {
      t29 = $[75];
    }
    let t30;
    if ($[76] !== isApproving) {
      t30 = isApproving ? /*#__PURE__*/_jsx(Loader2, {
        className: "h-3.5 w-3.5 animate-spin"
      }) : /*#__PURE__*/_jsx(Check, {
        className: "h-3.5 w-3.5"
      });
      $[76] = isApproving;
      $[77] = t30;
    } else {
      t30 = $[77];
    }
    let t31;
    if ($[78] !== isApproving || $[79] !== onApprove || $[80] !== t30) {
      t31 = /*#__PURE__*/_jsxs(Button, {
        size: "sm",
        onClick: onApprove,
        disabled: isApproving,
        className: "gap-1.5 bg-green-600 hover:bg-green-700",
        children: [t30, "Godk\xE4nn plats"]
      });
      $[78] = isApproving;
      $[79] = onApprove;
      $[80] = t30;
      $[81] = t31;
    } else {
      t31 = $[81];
    }
    let t32;
    if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
      t32 = /*#__PURE__*/_jsx(Trash2, {
        className: "h-3.5 w-3.5"
      });
      $[82] = t32;
    } else {
      t32 = $[82];
    }
    let t33;
    if ($[83] !== isRejecting || $[84] !== onOpenRejectDialog) {
      t33 = /*#__PURE__*/_jsxs(Button, {
        size: "sm",
        variant: "destructive",
        onClick: onOpenRejectDialog,
        disabled: isRejecting,
        className: "gap-1.5",
        children: [t32, "Avvisa"]
      });
      $[83] = isRejecting;
      $[84] = onOpenRejectDialog;
      $[85] = t33;
    } else {
      t33 = $[85];
    }
    let t34;
    if ($[86] !== t31 || $[87] !== t33) {
      t34 = /*#__PURE__*/_jsxs("div", {
        className: "mt-4 flex flex-wrap items-center gap-2",
        children: [t31, t33]
      });
      $[86] = t31;
      $[87] = t33;
      $[88] = t34;
    } else {
      t34 = $[88];
    }
    if ($[89] !== t29 || $[90] !== t34) {
      t13 = /*#__PURE__*/_jsxs("header", {
        className: "sticky top-0 z-10 border-b bg-white px-5 py-4",
        children: [t29, t34]
      });
      $[89] = t29;
      $[90] = t34;
      $[91] = t13;
    } else {
      t13 = $[91];
    }
    t9 = "px-5 py-4";
    let t35;
    if ($[92] === Symbol.for("react.memo_cache_sentinel")) {
      t35 = /*#__PURE__*/_jsx(MapPin, {
        className: "h-3.5 w-3.5"
      });
      $[92] = t35;
    } else {
      t35 = $[92];
    }
    let t36;
    if ($[93] !== isDirty) {
      t36 = isDirty && /*#__PURE__*/_jsx("span", {
        className: "ml-1 rounded-full bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold text-amber-800",
        children: "Osparade \xE4ndringar"
      });
      $[93] = isDirty;
      $[94] = t36;
    } else {
      t36 = $[94];
    }
    let t37;
    if ($[95] !== t36) {
      t37 = /*#__PURE__*/_jsxs("div", {
        className: "flex items-center gap-1.5 text-xs font-medium uppercase tracking-wider text-gray-400",
        children: [t35, "Position", t36]
      });
      $[95] = t36;
      $[96] = t37;
    } else {
      t37 = $[96];
    }
    let t38;
    if ($[97] !== isDirty) {
      t38 = !isDirty && /*#__PURE__*/_jsx("span", {
        className: "text-[10px] text-gray-400",
        children: "Dra platsmark\xF6ren f\xF6r att flytta"
      });
      $[97] = isDirty;
      $[98] = t38;
    } else {
      t38 = $[98];
    }
    if ($[99] !== t37 || $[100] !== t38) {
      t10 = /*#__PURE__*/_jsxs("div", {
        className: "mb-2 flex items-center justify-between gap-2",
        children: [t37, t38]
      });
      $[99] = t37;
      $[100] = t38;
      $[101] = t10;
    } else {
      t10 = $[101];
    }
    if ($[102] !== markers) {
      t11 = /*#__PURE__*/_jsx("div", {
        className: "h-64 overflow-hidden rounded border",
        children: markers.length > 0 ? /*#__PURE__*/_jsx(PlaceFeatureMap, {
          markers: markers,
          onMove: e => {
            if (e.kind === "place") {
              setPicked({
                latitude: e.latitude,
                longitude: e.longitude
              });
            }
          }
        }) : /*#__PURE__*/_jsx("div", {
          className: "flex h-full items-center justify-center bg-gray-50 text-xs text-gray-500",
          children: "Laddar karta\u2026"
        })
      });
      $[102] = markers;
      $[103] = t11;
    } else {
      t11 = $[103];
    }
    t8 = "mt-2 flex items-center justify-between gap-2";
    t6 = "text-[10px] text-gray-500";
    t7 = picked ? `${picked.latitude.toFixed(6)}, ${picked.longitude.toFixed(6)}` : `${savedLocation.latitude.toFixed(6)}, ${savedLocation.longitude.toFixed(6)}`;
    $[24] = isApproving;
    $[25] = isRejecting;
    $[26] = markers;
    $[27] = meta.categoryName;
    $[28] = meta.createdAt;
    $[29] = meta.creator?.name;
    $[30] = meta.location.latitude;
    $[31] = meta.location.longitude;
    $[32] = onApprove;
    $[33] = onOpenRejectDialog;
    $[34] = picked;
    $[35] = place.id;
    $[36] = place.name;
    $[37] = isDirty;
    $[38] = t10;
    $[39] = t11;
    $[40] = t12;
    $[41] = t13;
    $[42] = t6;
    $[43] = t7;
    $[44] = t8;
    $[45] = t9;
  } else {
    isDirty = $[37];
    t10 = $[38];
    t11 = $[39];
    t12 = $[40];
    t13 = $[41];
    t6 = $[42];
    t7 = $[43];
    t8 = $[44];
    t9 = $[45];
  }
  let t14;
  if ($[104] !== t6 || $[105] !== t7) {
    t14 = /*#__PURE__*/_jsx("p", {
      className: t6,
      children: t7
    });
    $[104] = t6;
    $[105] = t7;
    $[106] = t14;
  } else {
    t14 = $[106];
  }
  let t15;
  if ($[107] !== isDirty || $[108] !== isRepositioning) {
    t15 = isDirty && /*#__PURE__*/_jsxs(Button, {
      size: "sm",
      variant: "ghost",
      onClick: () => setPicked(null),
      disabled: isRepositioning,
      className: "h-8 gap-1 px-2 text-xs",
      title: "\xC5terst\xE4ll till sparad position",
      children: [/*#__PURE__*/_jsx(RotateCcw, {
        className: "h-3.5 w-3.5"
      }), "\xC5terst\xE4ll"]
    });
    $[107] = isDirty;
    $[108] = isRepositioning;
    $[109] = t15;
  } else {
    t15 = $[109];
  }
  const t16 = isDirty ? "default" : "outline";
  let t17;
  if ($[110] !== onReposition || $[111] !== picked) {
    t17 = () => {
      if (picked) {
        onReposition(picked);
      }
    };
    $[110] = onReposition;
    $[111] = picked;
    $[112] = t17;
  } else {
    t17 = $[112];
  }
  const t18 = !isDirty || isRepositioning;
  const t19 = isDirty && "bg-brand hover:bg-brand/90";
  let t20;
  if ($[113] !== t19) {
    t20 = cn("h-8 gap-1.5", t19);
    $[113] = t19;
    $[114] = t20;
  } else {
    t20 = $[114];
  }
  let t21;
  if ($[115] !== isRepositioning) {
    t21 = isRepositioning && /*#__PURE__*/_jsx(Loader2, {
      className: "h-3.5 w-3.5 animate-spin"
    });
    $[115] = isRepositioning;
    $[116] = t21;
  } else {
    t21 = $[116];
  }
  let t22;
  if ($[117] !== t16 || $[118] !== t17 || $[119] !== t18 || $[120] !== t20 || $[121] !== t21) {
    t22 = /*#__PURE__*/_jsxs(Button, {
      size: "sm",
      variant: t16,
      onClick: t17,
      disabled: t18,
      className: t20,
      children: [t21, "Spara position"]
    });
    $[117] = t16;
    $[118] = t17;
    $[119] = t18;
    $[120] = t20;
    $[121] = t21;
    $[122] = t22;
  } else {
    t22 = $[122];
  }
  let t23;
  if ($[123] !== t15 || $[124] !== t22) {
    t23 = /*#__PURE__*/_jsxs("div", {
      className: "flex items-center gap-1.5",
      children: [t15, t22]
    });
    $[123] = t15;
    $[124] = t22;
    $[125] = t23;
  } else {
    t23 = $[125];
  }
  let t24;
  if ($[126] !== t14 || $[127] !== t23 || $[128] !== t8) {
    t24 = /*#__PURE__*/_jsxs("div", {
      className: t8,
      children: [t14, t23]
    });
    $[126] = t14;
    $[127] = t23;
    $[128] = t8;
    $[129] = t24;
  } else {
    t24 = $[129];
  }
  let t25;
  if ($[130] !== t10 || $[131] !== t11 || $[132] !== t24 || $[133] !== t9) {
    t25 = /*#__PURE__*/_jsxs("section", {
      className: t9,
      children: [t10, t11, t24]
    });
    $[130] = t10;
    $[131] = t11;
    $[132] = t24;
    $[133] = t9;
    $[134] = t25;
  } else {
    t25 = $[134];
  }
  let t26;
  if ($[135] !== place.features) {
    t26 = place.features.length > 0 && /*#__PURE__*/_jsxs("section", {
      className: "px-5 py-4",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "mb-3 text-xs font-medium uppercase tracking-wider text-gray-400",
        children: ["Bifogade funktioner (", place.features.length, ")"]
      }), /*#__PURE__*/_jsx("div", {
        className: "space-y-2",
        children: place.features.map(_temp)
      }), /*#__PURE__*/_jsx("p", {
        className: "mt-2 text-xs text-gray-500",
        children: "Funktioner godk\xE4nns separat i Funktioner-fliken efter att platsen \xE4r godk\xE4nd."
      })]
    });
    $[135] = place.features;
    $[136] = t26;
  } else {
    t26 = $[136];
  }
  let t27;
  if ($[137] !== placeId) {
    t27 = /*#__PURE__*/_jsx(AuditHistoryAccordion, {
      entityType: "place",
      entityId: placeId
    });
    $[137] = placeId;
    $[138] = t27;
  } else {
    t27 = $[138];
  }
  let t28;
  if ($[139] !== onCloseRejectDialog || $[140] !== onReject) {
    t28 = reason => {
      onReject(reason);
      onCloseRejectDialog();
    };
    $[139] = onCloseRejectDialog;
    $[140] = onReject;
    $[141] = t28;
  } else {
    t28 = $[141];
  }
  let t29;
  if ($[142] !== isRejecting || $[143] !== onCloseRejectDialog || $[144] !== place.features.length || $[145] !== place.name || $[146] !== rejectDialogOpen || $[147] !== t28) {
    t29 = /*#__PURE__*/_jsx(RejectDialog, {
      open: rejectDialogOpen,
      entityType: "place",
      targetName: place.name,
      cascadeFeatureCount: place.features.length,
      isSubmitting: isRejecting,
      onClose: onCloseRejectDialog,
      onSubmit: t28
    });
    $[142] = isRejecting;
    $[143] = onCloseRejectDialog;
    $[144] = place.features.length;
    $[145] = place.name;
    $[146] = rejectDialogOpen;
    $[147] = t28;
    $[148] = t29;
  } else {
    t29 = $[148];
  }
  let t30;
  if ($[149] !== t12 || $[150] !== t13 || $[151] !== t25 || $[152] !== t26 || $[153] !== t27 || $[154] !== t29) {
    t30 = /*#__PURE__*/_jsxs("div", {
      className: t12,
      children: [t13, t25, t26, t27, t29]
    });
    $[149] = t12;
    $[150] = t13;
    $[151] = t25;
    $[152] = t26;
    $[153] = t27;
    $[154] = t29;
    $[155] = t30;
  } else {
    t30 = $[155];
  }
  return t30;
}
function _temp(f_0) {
  return /*#__PURE__*/_jsx(FeatureCard, {
    feature: f_0
  }, f_0.id);
}